import { Controller } from 'stimulus'
import Rails from '@rails/ujs'
import flatpickr from 'flatpickr'

export default class DaysController extends Controller {
  static targets = ['container', 'form', 'content', 'addBtn']

  connect () {
    // console.log('rituals connected')
  }

  onPostSuccess (event) {
    const that = this
    const [data, status, xhr] = event.detail
    // console.log('onPostSuccess')
    // console.log(status)
    const response = JSON.parse(xhr.response)
    // let datePicker = null
    //
  }

  onCreateSuccess (event) {
    const [data, status, xhr] = event.detail
    // console.log('onCreateSuccess')
    // console.log(xhr.response)
    const response = JSON.parse(xhr.response)
    // console.log(response.list_item)

    this.contentTarget.insertAdjacentHTML('beforeend', response.day)
    const daysList = document.getElementById('days-list')
    if (daysList) {
      document.getElementById('days-list').insertAdjacentHTML('beforeend', response.list_item)
    }

    flatpickr('.flatpickr', {
      altInput: true,
      altFormat: 'M j, Y',
      dateFormat: 'Y-m-d'
    })
  }

  submit (e) {
    Rails.fire(this.formTarget, 'submit')
  }

  deleteConfirm (event) {
    const that = this

    event.preventDefault()
    const target = event.currentTarget
    const url = target.dataset.url

    iziToast.question({
      timeout: 20000,
      close: false,
      overlay: true,
      displayMode: 'once',
      id: 'confirmDayDelete',
      zindex: 9999,
      title: 'Confirm',
      message: 'Are you sure you want to delete this day?',
      position: 'center',
      buttons: [
        ['<button><b>YES</b></button>', function (instance, toast) {
          instance.hide({ transitionOut: 'fadeOut' }, toast, 'button')
          that.delete(target, url)
          return true
        }, true],
        ['<button>NO</button>', function (instance, toast) {
          instance.hide({ transitionOut: 'fadeOut' }, toast, 'button')
          return false
        }]
      ]
    })
  }

  delete (target, url) {
    const currentTarget = target
    Rails.ajax({
      type: 'delete',
      url: url,
      success: function (response) {
        currentTarget.parentNode.parentNode.remove()
      },
      error: function (response) {
        iziToast.warning({
          title: 'Error',
          message: 'We encountered an error when deleting this day.'
        })
      }
    })
  }

  add (e) {
    const that = this
    const url = this.addBtnTarget.dataset.url
    Rails.ajax({
      type: 'post',
      url: url,
      success: function (response) {
        const daysList = document.getElementById('days-list')
        if (daysList) {
          document.getElementById('days-list').insertAdjacentHTML('beforeend', response.list_item)
        }
        that.contentTarget.insertAdjacentHTML('beforeend', response.day)
        flatpickr('.flatpickr', {
          altInput: true,
          altFormat: 'M j, Y',
          dateFormat: 'Y-m-d'
        })
        /*
        const textfield = newNode.querySelectorAll('input[type=text]')[0]
        if (textfield) {
          textfield.focus()
        }
        */
      },
      error: function (response) {
        iziToast.warning({
          title: 'Error',
          message: 'We encountered an error when adding a new day.'
        })
      }
    })
  }
}
